/** Rows-per-page choices offered by every paged list. */
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 25, 50] as const;

export const DEFAULT_ROWS_PER_PAGE = DEFAULT_ROWS_PER_PAGE_OPTIONS[0];
